// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"65abfb2d","228":"c6d284b4","453":"d19810ff","524":"05780ccd","742":"374bc048"}[chunkId] + ".chunk.js";
};